import React from "react";

const AuthStepIndicator = ({ currentStep, steps, stepLabel }) => {
  const progressWidth = `${(currentStep / steps) * 100}%`;

  return (
    <div className="mb-8">
      <div className="mb-3 flex items-center justify-between text-[13px] font-medium uppercase tracking-[0.16em] text-[#111111]">
        <span>
          Schritt {currentStep} von {steps}
        </span>
        <span className="normal-case tracking-normal text-[#374151]">
          {stepLabel}
        </span>
      </div>

      <div className="h-[4px] w-full overflow-hidden rounded-full bg-[#dfdfdf]">
        <div
          className="h-full rounded-full bg-black transition-all duration-300"
          style={{ width: progressWidth }}
        />
      </div>
    </div>
  );
};

export default AuthStepIndicator;
